import React, { useState } from 'react';
import './Lost.css';
import Modal from './Modal';

const Lost = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="lost-section">
        <div className="lost-content">
          <h2 className="lost-title">
          <strong>Feeling lost in the world of online ordering?</strong> Well you've come to the right place...
          </h2>
          
          <p className="lost-description">
          This quick restaurant online ordering assessment is the first step in transforming how your restaurant takes orders, connects with customers, and grows online. Perfect for pizza restaurants, delis, Chinese restaurants, Mexican restaurants, Thai restaurants, Indian restaurants, Japanese restaurants, and all restaurant types.
          </p>
          
          <button className="lost-button" onClick={handleButtonClick}>
            Take the Assessment!
          </button>
          
          <p className="lost-disclaimer">
            It's free and only takes 5 minutes
          </p>
        </div>
      </div>
      
      <Modal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default Lost;
